import { Select, DatePicker, Input, Button, Form, Row, Col } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { isAuthenticated } from "../../Auth/auth";
import DragUpload from "../../DragUpload/DragUpload";
import { Error, Success } from "../../Messages/Messages";
import { assetTypes } from "../../../utils/assetTypes";
import GeneralModal from "../../../serviceProvider/components/General.modal";
import MainButtonComp from "../../Buttons/MainButtonComp";
import { Typography } from "antd";

import { useTranslation } from "react-i18next";
const { TextArea } = Input;

const statusArray = [
  { label: "Active", value: "Active" },
  { label: "Not Available", value: "Not Available" },
  { label: "Taken", value: "Taken" }
];

const AddAssets = ({ updateParent, employeeObject, serviceProvider }) => {
  const { t } = useTranslation("dashboard");
  const [employeesArray, setEmployeesArray] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const { Title } = Typography;

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        ...values,
        employee: employeeObject?._id || values.employee,
        serviceProvider: isAuthenticated()?.serviceProviderId
      };

      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/assets/add`, payload, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      });

      if (res.status === 200 || res.status === 304) {
        Success(res.data.successMessage);
        updateParent();
        handleCancel();
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      if (err.response?.data?.errorMessage) {
        Error(err.response.data.errorMessage);
      } else {
        console.error(err);
        Error(err.message);
      }
    }
  };

  const getData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/employees/employee/creator/${isAuthenticated()?.serviceProviderId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      );

      if (res.status === 200 || res.status === 304) {
        const options = res.data.map(d => ({
          label: `${d.firstName} ${d.lastName}`,
          value: d._id
        }));
        setEmployeesArray(options);
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      Error(err.response?.data?.errorMessage || err.message);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const items = (
    <Form
      form={form}
      layout="vertical"
      initialValues={{
        employee: employeeObject?._id
      }}
    >
      <Row gutter={[16, 0]}>
        <Col xs={24} md={12}>
          <Form.Item
            label={
              <Title level={5} className="modals-inputs-label">
                {t("Asset Type")}
              </Title>
            }
            name="type"
            rules={[{ required: true, message: t("Please select an asset type") }]}
          >
            <Select
              style={{ width: "100%" }}
              size="large"
              options={assetTypes.map(type => ({
                value: type,
                label: type
              }))}
              placeholder={t("Select Asset Type")}
              allowClear
              showSearch
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label={
              <Title level={5} className="modals-inputs-label">
                {t("Title")}
              </Title>
            }
            name="title"
            rules={[{ required: true, message: t("Please enter a title") }]}
          >
            <Input style={{ width: "100%" }} size="large" placeholder={t("Title")} />
          </Form.Item>
        </Col>
        {serviceProvider && (
          <>
            <Col xs={24} md={12}>
              <Form.Item
                label={
                  <Title level={5} className="modals-inputs-label">
                    {t("Status")}
                  </Title>
                }
                name="status"
                rules={[{ required: true, message: t("Please select a status") }]}
              >
                <Select
                  style={{ width: "100%" }}
                  size="large"
                  options={statusArray.map(o => ({ ...o, label: t(o.label) }))}
                  placeholder={t("Select Status")}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={
                  <Title level={5} className="modals-inputs-label">
                    {t("Taken By Employee")}
                  </Title>
                }
                name="employee"
                rules={[{ required: true, message: t("Please select Employee") }]}
              >
                <Select
                  style={{ width: "100%" }}
                  size="large"
                  options={employeesArray}
                  placeholder={t("Select Employee")}
                  allowClear
                  showSearch
                />
              </Form.Item>
            </Col>
          </>
        )}
        <Col xs={24} md={12}>
          <Form.Item
            label={
              <Title level={5} className="modals-inputs-label">
                {t("Taken Start Date")}
              </Title>
            }
            name="startDate"
            rules={[{ required: true, message: t("Please select a start date") }]}
          >
            <DatePicker style={{ width: "100%" }} size="large" format={"DD/MMM/YYYY"} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            label={
              <Title level={5} className="modals-inputs-label">
                {t("Taken End Date")}
              </Title>
            }
            name="endDate"
            rules={[{ required: true, message: t("Please select an end date") }]}
          >
            <DatePicker style={{ width: "100%" }} size="large" format={"DD/MMM/YYYY"} />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Form.Item
            label={
              <Title level={5} className="modals-inputs-label">
                {t("Description")}
              </Title>
            }
            name="description"
            rules={[{ required: true, message: t("Please enter a description") }]}
          >
            <TextArea rows={4} />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Form.Item
            label={
              <Title level={5} className="modals-inputs-label">
                {t("Notes")}
              </Title>
            }
            name="notes"
          >
            <TextArea rows={2} />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <div className="project-files-dragger">
            <Form.Item
              label={
                <Title level={5} className="modals-inputs-label">
                  {t("Files")}
                </Title>
              }
              name="files"
            >
              <DragUpload updateFiles={files => form.setFieldValue("files", files)} />
            </Form.Item>
          </div>
        </Col>
      </Row>
    </Form>
  );

  return (
    <div className="AddAssets">
      <MainButtonComp text="Add Assets" addBtn onClick={showModal} />
      <GeneralModal
        title={t("Add Assets")}
        onOk={onSubmit}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        onChange={() => {}}
        items={items}
      />
    </div>
  );
};

export default AddAssets;
